import { createContext, Suspense, useContext, useEffect } from "react";
import Router from "./Router";
import ProviderApp, { ThemeContext } from "./ProviderApp";
import { CellPortalHost } from "@CubeComponents/html/cellPortals";
import UserProfileModalHost from "@Components/UserProfileModalComponent/UserProfileModalHost";
import { PlatformStatusGate } from "@Features/platform-status";

// An ambient global published by a third-party script tag, with no shipped types. `unknown` rather
// than `any` is safe here because nothing reads members off it: `PubSubContext` has no consumers
// anywhere in the codebase, and `ProviderApp` supplies `undefined as never` to its only Provider.
declare const PubSubHelper: unknown;

export const PubSubContext = createContext({
  PubSubHelper: PubSubHelper,
});

function App() {
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    const handlePreloadError = () => globalThis.location.reload();
    globalThis.addEventListener("vite:preloadError", handlePreloadError);
    return () => globalThis.removeEventListener("vite:preloadError", handlePreloadError);
  }, []);

  return (
    <ProviderApp>
      {/* [portal-pilot] single host that renders SlickGrid cell React content via portals under the app providers */}
      <CellPortalHost />
      {/* single app-level mount for user-profile modals opened from plain-DOM grid cells */}
      <UserProfileModalHost />
      <div
        className="App"
        style={{
          opacity: 1,
          background: `var(${theme.rootBackground})`,
          color: `var(${theme.rootTextColor})`,
        }}
      >
        <Suspense fallback={<></>}>
          <Router />
        </Suspense>
      </div>
      {/* maintenance / backend-unreachable screens, over the app rather than instead of it */}
      <PlatformStatusGate />
    </ProviderApp>
  );
}

export default App;
